import { Switch, Text } from "@mantine/core";

type SwitchCardProps = {
	title: string;
	description: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled: boolean;
};

export function SwitchCard({
	title,
	description,
	checked,
	onChange,
	disabled,
}: SwitchCardProps) {
	return (
		<div className="flex justify-between items-center py-4 bg-surface-subtle px-4 rounded-xl border border-border-subtle shadow-sm transition-all hover:shadow-md">
			<div className="flex flex-col gap-1">
				<Text size="md" fw={700} className="text-text-primary">
					{title}
				</Text>
				<Text size="xs" className="text-text-secondary">
					{description}
				</Text>
			</div>
			<Switch
				disabled={disabled}
				size="md"
				color="var(--ui-color-brand-primary)"
				classNames={{
					track: !disabled ? "cursor-pointer hover:bg-brand-primary-hover" : "",
				}}
				checked={checked}
				onChange={(e) => onChange(e.currentTarget.checked)}
			/>
		</div>
	);
}
